import React from 'react';
import Ionicon from "react-ionicons";
import { ErrorModal } from '../../elements/ui';
//import { render } from 'react-dom';

export const OpenFormError = props => {
    const { error, isGuestMode } = props;

    if (!error) return null;
    if (isGuestMode) return null;

    if (error) scrollToElement();

    return (
        <div className="profile-error-message">
            <Ionicon icon="ion-alert"/>
            <span className="message">Another form is already open. Please save your work or cancel to proceed.</span>
            <ErrorModal onClose={() => document.querySelector('.popup-default').remove()}/>
        </div>
    )
}

const scrollToElement = () => {
    const formStandardProfile = document.querySelector('.form-standard-profile');
    const achievements = document.querySelector('.achievements-type');
    const endorsements = document.querySelector('.endorsement-manager');
    formStandardProfile !== null ? formStandardProfile.scrollIntoView({ behavior: "smooth", block: "center" }) : null;
    achievements !== null & formStandardProfile === null ? achievements.scrollIntoView({ behavior: "smooth", block: "center" }) : null;
    endorsements !== null & formStandardProfile === null ? endorsements.scrollIntoView({ behavior: "smooth", block: "center" }) : null;
}



// class OpenFormError extends Component {

//     constructor(props){
//         super(props);
//         this.state={
//             papuk: 123
//         };
//     }

//     scrollToElement = () => {
//         const formStandardProfile = document.querySelector('.form-standard-profile');
//         const achievements = document.querySelector('.achievements-type');
//         formStandardProfile !== null ? formStandardProfile.scrollIntoView({behavior: "smooth", block: "center"}) : null;
//         achievements !== null & formStandardProfile === null ? achievements.scrollIntoView({behavior: "smooth", block: "center"}) : null;
//     }


//     render() {
//         console.log(this.props);
//         const { error } = this.props;

//         //if (!error) return null;

//         if (error) this.scrollToElement();

//         return (
//             <div className="profile-error-message">
//                 <Ionicon icon="ion-alert"/>
//                 <span className="message">Another form is already open. Please save your work or cancel to proceed.</span>
//             </div>
//         )
//     }
// }

// export default OpenFormError;



// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/ui/OpenFormError.js